import { retrieveBulkTimes } from '@/api/common'
import { useQuery } from '@tanstack/vue-query'

const bulkDiscountNum = ref(0)

export const useSpuBulkDiscount = (spu) => {
  const { data: bulkTimes } = useQuery({
    queryKey: ['/appb/b2b/product/quote/bulkTimes'],
    queryFn: retrieveBulkTimes
  })

  const isShowBulkDiscountWithMOQ = computed(() => {
    if (bulkTimes.value == null) return false
    const selected = spu.value.skuDetails.reduce((pre, item) => {
      if (item.checked) {
        pre += item.quantity
      }
      return pre
    }, 0)
    const minBulkDiscountNumber = spu.value.batchNum * bulkTimes.value
    return selected >= minBulkDiscountNumber
  })

  const isBulkDiscount = computed(() => {
    if (spu.value.hasConfirmedPackage) return spu.value.bulkPackFlag
    return isShowBulkDiscountWithMOQ.value
  })

  watch(isBulkDiscount, (val) => {
    bulkDiscountNum.value = val ? bulkDiscountNum.value + 1 : bulkDiscountNum.value - 1
  })

  return {
    isBulkDiscount
  }
}

export const useBulkDiscount = () => {
  const isBulkDiscount = computed(() => bulkDiscountNum.value > 0)

  return {
    isBulkDiscount
  }
}
